// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"313bf5e3241c7e0e3812","655":"e9c2443430248a1477d7"}[chunkId] + ".js";
};